export const JOB_SEARCH_FILTER_TYPES = Object.freeze({
    COMPANY: 'company_id',
    LOCATION: 'locations',
    QUICK_APPLY: 'quick_apply',
    REMOTE: 'remote',
});
